import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  RadialLinearScale,
  LinearScale,
  LineElement,
  LineController,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar, Radar } from 'react-chartjs-2';
import {floatFormatter} from '../Common/util';
import { chart_options_bar, chart_options_radar } from '../Common/options';

ChartJS.register(
  CategoryScale,
  RadialLinearScale,
  LinearScale,
  LineElement,
  LineController,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
);


export function Chart01({dataList, sumData}) {

    const options = chart_options_bar;
    
    const c_label = '';
    const c_labels = [];
    dataList.map(row => c_labels.push(row.name + ' [ '+row.level+' ] '));
    const c_data = [];
    dataList.forEach(row => c_data.push(row.level));

    const avg_data = [];
    dataList.forEach(row => avg_data.push(sumData.level));
    
    const data = {
      // 각 막대별 라벨
      labels: c_labels,
      datasets: [
        {
          type: 'bar',
          label: c_label,
          data: c_data, // 수치
          borderWidth: 1, // 테두리 두께
          backgroundColor: [
            'rgba(255, 200, 200, 0.5)',
            'rgba(255, 200, 150, 0.5)',
            'rgba(255, 230, 150, 0.5)',
            'rgba(200, 255, 255, 0.5)',
            'rgba(200, 200, 255, 0.5)',
            'rgba(230, 150, 255, 0.5)',
            'rgba(201, 203, 207, 0.5)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
        }
      ]
    };

    return (<Bar key={1} options={options} data={data}/>);
}

/** --------------------------------------------------- */

export function Chart02({ dataList, sumData}) {

  const options = chart_options_radar;
  
  const c_label = '';
  const c_labels = [];
  dataList.map(row => c_labels.push(row.name + ' [ '+row.level+' ] '));
  const c_data = [];
  dataList.forEach(row => c_data.push(row.level));
  
  const data = {
    // 각 막대별 라벨
    labels: c_labels,
    datasets: [
      {
        type: 'radar',
        label: c_label,
        data: c_data, // 수치
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      }
    ]
  };
  return (<Radar key={1} options={options} data={data}/>);
}



/** --------------------------------------------------- */

export function Chart03({dataList, sumData}) {

  const options = chart_options_bar;
  
  const c_label = '';
  const c_labels = [];
  dataList.map(row => c_labels.push(row.name + ' [ '+row.level+' ] '));
  const c_data = [];
  dataList.forEach(row => c_data.push(row.level));

  const avg_data = [];
  dataList.forEach(row => avg_data.push(sumData.level));
  
  const data = {
    // 각 막대별 라벨
    labels: c_labels,
    datasets: [
      {
        type: 'bar',
        label: c_label,
        data: c_data, // 수치
        borderWidth: 1, // 테두리 두께
        backgroundColor: [
          'rgba(255, 200, 200, 0.5)',
          'rgba(255, 200, 150, 0.5)',
          'rgba(255, 230, 150, 0.5)',
          'rgba(200, 255, 255, 0.5)',
          'rgba(200, 200, 255, 0.5)',
          'rgba(230, 150, 255, 0.5)',
          'rgba(201, 203, 207, 0.5)'
        ],
        borderColor: [
          'rgb(255, 99, 132)',
          'rgb(255, 159, 64)',
          'rgb(255, 205, 86)',
          'rgb(75, 192, 192)',
          'rgb(54, 162, 235)',
          'rgb(153, 102, 255)',
          'rgb(201, 203, 207)'
        ],
      }
    ]
  };
  return (<Bar key={1} options={options} data={data}/>);
}


/** --------------------------------------------------- */

export function Chart04({compareSumData}) {

  const options = { ...chart_options_bar, barThickness: 250};
  
  const c_label = '';
  const c_labels = [];
  c_labels.push('조치전 [' + floatFormatter(compareSumData.level,1) + ']');
  c_labels.push('이행진단 [' + floatFormatter(compareSumData.level_U,1) + ']');
  const c_data = [];
  c_data.push(floatFormatter(compareSumData.level,1));
  c_data.push(floatFormatter(compareSumData.level_U,1));

  const data = {
    // 각 막대별 라벨
    labels: c_labels,
    datasets: [
      {
        type: 'bar',
        label: c_label,
        data: c_data, // 수치
        borderWidth: 1, // 테두리 두께
        backgroundColor: [
          'rgba(255, 200, 200, 0.5)',
          'rgba(255, 200, 150, 0.5)',
          'rgba(255, 230, 150, 0.5)',
          'rgba(200, 255, 255, 0.5)',
          'rgba(200, 200, 255, 0.5)',
          'rgba(230, 150, 255, 0.5)',
          'rgba(201, 203, 207, 0.5)'
        ],
        borderColor: [
          'rgb(255, 99, 132)',
          'rgb(255, 159, 64)',
          'rgb(255, 205, 86)',
          'rgb(75, 192, 192)',
          'rgb(54, 162, 235)',
          'rgb(153, 102, 255)',
          'rgb(201, 203, 207)'
        ],
      }
    ]
  };
  return (<Bar key={1} options={options} data={data}/>);
}
